import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { change, reduxForm } from 'redux-form';
import {
  resetFiltersAndSorting,
  showFormatedDate, showNormalizedRate } from '../../../../actions/utilAction';
import { CommonButton } from '../../../../components/buttons';
import { getLedgerClaimServiceDetails, getMasterData, getPaymentDetails, deleteServiceLinePayment } from './actions/index';
import moment from 'moment';
import ClaimServiceLineModal from './claimServiceLineModal';
import Alert from 'react-s-alert';


class ClaimServiceLines extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      patientId: props.patientId,
      claimId: props.claimId,
      paymentId: null,
      serviceLineId: null,
    };
    this.filter = {
      sort_Column: 'claimId',
      sort_Order: 'desc',
      searchText: '',
    };
    this.handleSearchPaymentDetails = this.handleSearchPaymentDetails.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.onSubmitPaymentDetail = this.onSubmitPaymentDetail.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
    this.handleBackClick = this.handleBackClick.bind(this);
  }
  loadModalData(paymentId) {
    // let masterData = {
    //   'masterdata': 'MASTERPAYMENTTYPE,MASTERPAYMENTDESCRIPTION',
    // };
    // this.props.getMasterData(masterData);
    if (paymentId) {
      this.props.getPaymentDetails(paymentId);
    }
  }
  loadData() {
    // console.log('patientId....', this.state.patientId)
    if (this.state.claimId) {
      this.props.getLedgerClaimServiceDetails(this.state.claimId);
    }
  }
  componentWillMount() {
    let masterData = {
      'masterdata': 'MASTERPAYMENTTYPE,MASTERPAYMENTDESCRIPTION,MASTERADJUSTMENTGROUPCODE',
    };
    this.props.getMasterData(masterData);
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.addedPaymentDetails && nextProps.addedPaymentDetails !== this.props.addedPaymentDetails) {
      this.loadData();
    }
  }

  handleSearchPaymentDetails(e) {
    // event.preventDefault();
    if (!(this.state.PayerId || this.state.FromDate || this.state.ToDate)) {
      return false;
    }
    this.loadData();
  }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;
      this.loadData();
    }
  }

  handleReset = () => {
    // this.props.dispatch(reset('PaymentDetailForm'));
    // this.props.dispatch(change('PaymentDetailForm', 'PayerId', null));
    this.props.dispatch(change('PaymentDetailForm', 'FromDate', null));
    this.props.dispatch(change('PaymentDetailForm', 'ToDate', null));
    resetFiltersAndSorting(this.filter, 'claimId', true);
    this.setState({
      FromDate: null,
      ToDate: null,
    }, () => {
      this.loadData();
    });
  };

  handleAddClick(e, obj) {
    this.loadModalData();
    this.setState({ open: true, paymentId: null, serviceLineId: obj.id });
  }

  handleEditClick(e, obj) {
    this.loadModalData(obj.id);
    this.setState({ open: true, paymentId: obj.id, serviceLineId: obj.serviceLineId });
  }

  handleCloseDialog() {
    this.setState({ open: false, paymentId: null, serviceLineId: null });
  }

  handleBackClick() {
    this.props.onBackClick();
  }

  handleNewRequest(input, selectedValue) {
    input.onChange(selectedValue.value);
  }

  onSubmitPaymentDetail(formValues) {
    // console.log(formValues);
  }

  handleExpandRow = (Id) => {
    this.setState({ Id: Id });
    let display = this.refs['expandedClass' + Id].style.display;
    if (display === 'none') {
      this.refs['expandedClass' + Id].style.display = 'table-row';
      this.refs['expClass' + Id].className = 'classExpand fa fa-minus';
    } else {
      this.refs['expandedClass' + Id].style.display = 'none';
      this.refs['expClass' + Id].className = 'classExpand fa fa-ellipsis-h';
    }
  }

  handleAlertClick = (event, paymentDetailId) => {
    this.props.deleteServiceLinePayment(paymentDetailId, this.state.claimId);
    Alert.closeAll();
  }

  componentWillUnmount() {
    Alert.closeAll();
  }

  handleDeleteClick = (e, obj) => {
    let warningMsg = `Are you sure you want to delete this payment?`;
    Alert.warning(warningMsg, {
      position: 'bottom-right',
      effect: 'slide',
      html: true,
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  };

  renderInnerData(serviceLineId) {
    let serviceInnerData = this.props.ledgerClaimServicePaymentDetails || [],
      filteredPaymentData = serviceInnerData.filter((obj) => obj.serviceLineId === serviceLineId);

    if (!filteredPaymentData.length) {
      return <tr><td colSpan="7" className="text-center no-record">No record found.</td></tr>;
    }
    return filteredPaymentData.map((obj, paymentIndex) => {
      return (
        <tr key={paymentIndex}>
          <td></td>
          <td>{obj.paymentDate ? showFormatedDate(obj.paymentDate) : '-'}</td>
          <td>{obj.payerName ? obj.payerName : obj.patientName ? 'Self' : 'Guarantor'}</td>
          <td>{obj.paymentType || '-'}</td>
          <td>{obj.descriptionType || '-'}</td>
          <td>{showNormalizedRate(obj.amount || 0)}</td>
          <td>
            <button onClick={(e) => this.handleEditClick(e, obj)} type="button" title="Edit Payment" className="tbactionbtn bluefont"><i className="fa fa-edit" aria-hidden="true"></i></button>
            <button onClick={(e) => this.handleDeleteClick(e, obj)} type="button" title="Delete Payment" className="tbactionbtn redfont"><i className="fa fa-trash" aria-hidden="true"></i></button>
          </td>
        </tr>
      );
    });
  }

  renderData() {
    const tableClass1 = classNames({
      'table': true,
      'middletable': true,
      'customtable': true,
    });
    const tableClass2 = classNames({
      'table': true,
      'childtable': true,
    });
    let serviceLinesData = this.props.ledgerClaimServiceDetails || [];

    if (!serviceLinesData.length) {
      return (<tr>
        <td colSpan='8' className="text-center no-record">{this.props.loading ? 'Loading, Please wait...' : 'No record found.'}</td>
      </tr>);
    }

    return serviceLinesData.map((obj, serviceIndex) => {

      return (
        <tr key={obj.id}>
          <td colSpan="8">
            <table className={tableClass1}>
              <tbody>
                <tr>
                  <td width="5%">
                    <div className="table_custom-check">
                      <button onClick={(e) => this.handleExpandRow(obj.id)} type="button" className="morebtn">
                        <i ref={'expClass' + obj.id} className="classExpand fa fa-ellipsis-h" aria-hidden="true"></i>
                      </button>

                    </div>
                  </td>
                  <td width="13%">{obj.serviceCode || '-'}</td>
                  <td width="12%">{showNormalizedRate(obj.totalAmount || 0)}</td>
                  <td width="12%">{showNormalizedRate(obj.insurancePayments || 0)}</td>
                  <td width="12%">{showNormalizedRate(obj.insuranceAdjustments || 0)}</td>
                  <td width="12%">{showNormalizedRate(obj.patientPayments || 0)}</td>
                  <td width="12%">{showNormalizedRate(obj.patientAdjustments || 0)}</td>
                  {/* <td width="8%">{showNormalizedRate(obj.balanceWithoutAdjustment || 0)}</td>
                  <td width="7%">{showNormalizedRate(obj.balanceWithAdjustment || 0)}</td> */}
                  <td width="5%">
                    <button onClick={(e) => this.handleAddClick(e, obj)} type="button" title="Add Payment" className="tbactionbtn redfont"><i className="fa fa-plus-square" aria-hidden="true"></i></button>
                  </td>
                </tr>
                <tr className="nohover" ref={'expandedClass' + obj.id} style={{ 'display': 'none' }}>
                  <td colSpan="8">
                    <table className={tableClass2}>
                      <thead>
                        <tr>
                          <th width="5%"></th>
                          <th width="15%">Date of Payment</th>
                          <th width="25%">Payment Source Name</th>
                          <th width="15%">Payment Type</th>
                          <th width="15%">Description Type</th>
                          <th width="15%">Amount($)</th>
                          <th width="10%">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderInnerData(obj.id)}
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      );
    });
  }

  render() {
    // console.log('ledgerClaimServiceDetails...', this.props.ledgerClaimServiceDetails);
    // let recordsCount = ledgerClaimServiceDetails.length;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.bordered,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'maintable': true,
      'customtable': true,
    });


    return (
      <div>
        {this.state.open ?
          <ClaimServiceLineModal
            open={this.state.open}
            patientId={this.state.patientId}
            paymentId={this.state.paymentId}
            serviceLineId={this.state.serviceLineId}
            closeDialog={this.handleCloseDialog}
            claimId={this.state.claimId}/>
          : null}

        <div className="row">
          <div className="col-sm-12">
            <div className="panel_title no_margin">
              <CommonButton className="mt-10" label="Back" primary={true} onTouchTap={this.handleBackClick} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <div className="table-responsive mt-20">
              <table className={tableClass}>
                <thead>
                  <tr>
                    <th width="5%">
                      <div className="table_custom-check">
                        {/* <Field
                              name='Chkclaim'
                              component={renderCheckBox}
                              style={stylescss.checkbox}
                            /> */}
                        <span>&nbsp;</span>
                      </div>
                    </th>
                    <th width="13%">
                      {/* <SortingCustom setSortColumn={this.setSortColumn} columnName='claimId' displayName='Claim ID' /> */}
                          Service Code
                    </th>
                    <th width="12%">Total Amt.($)</th>
                    <th width="12%">Ins. Paid($)</th>
                    <th width="12%">Ins. Adj($)</th>
                    <th width="12%">Pat. Paid($)</th>
                    <th width="12%">Pat. Adj($)</th>
                    {/* <th width="8%">Bal.W/out Adjust($)</th>
                    <th width="7%">Bal.W/ Adjust($)</th> */}
                    <th width="5%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderData()}
                </tbody>
              </table>
              {/* <PaginatorCustom data={this.props.readyToBillClaims.meta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} /> */}


            </div>
          </div>
        </div>
      </div>
    );
  }
}
ClaimServiceLines = reduxForm({
  form: 'ClaimServiceLinesForm',
  enableReinitialize: true,
})(ClaimServiceLines);

function mapStateToProps(state) {
  // console.log('state..........', state);
  let ledgerClaimServiceDetails = [],
    ledgerClaimServicePaymentDetails = [];
  if (state.ledger.ledgerClaimServiceDetails) {
    ledgerClaimServiceDetails = state.ledger.ledgerClaimServiceDetails.data.ServiceLines;
    ledgerClaimServicePaymentDetails = state.ledger.ledgerClaimServiceDetails.data.PaymentList;
  }
  return {
    loading: state.ledger.loading,
    ledgerClaimServiceDetails: ledgerClaimServiceDetails || [],
    ledgerClaimServicePaymentDetails: ledgerClaimServicePaymentDetails || [],
    addedPaymentDetails: state.ledger.addedPaymentDetails,
    // initialValues: state.billing.claimsWithServiceLinesForPayerDetails,
  };

}
export default connect(mapStateToProps, { getLedgerClaimServiceDetails, getMasterData, getPaymentDetails, deleteServiceLinePayment })(ClaimServiceLines);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/Ledger/claimServiceLines.js